<template>
  <div>
    <q-select
      v-model="status"
      :options="listaStatus"
      class="input-mobile"
      dense
      outlined
      @input-value="setModel"
      option-label="status"
      behavior="menu"
      label="Selecione o Status"
      label-color="grey-6"
      @filter="filtrarStatus"
      use-input
    />
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  emits: ["enviarStatus"],
  props: ["model", "resetar", "catalogoUuid", "exibirTodos", "externo"],
  setup(props, { emit }) {
    const store = useStore();

    const status = ref(props.model);
    const listaStatus = ref([]);

    const listarStatus = async (val) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/listarStatusAtivos",
          {
            catalogoUuid:
              props.catalogoUuid || store.state.ferramentaria.catalogoUuid,
            status: val,
          }
        );
        let array = [];

        if (response.data.resultado.dados.length > 0) {
          response.data.resultado.dados.forEach((status) => {
            const temExclusao =
              status.excluidoEm &&
              status.excluidoEm !== null &&
              status.excluidoEm !== "";

            if (!temExclusao) {
              array.push(status);
            }
          });
        }
        listaStatus.value = array;
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => props.resetar,
      () => {
        status.value = "";
      }
    );

    watch(
      () => status.value,
      () => {
        emit("enviarStatus", status.value);
      }
    );

    return {
      status,
      listaStatus,
      listarStatus,
      setModel(val) {
        if (val === "") {
          status.value = val;
        }
      },
      filtrarStatus(val, update) {
        listarStatus(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .input-mobile {
    font-size: 12px;
  }
}
</style>
